export default __webpack_public_path__ + "static/media/gitback.9fcbc6c2.svg";